import { render, staticRenderFns } from "./institutionPatternTable.vue?vue&type=template&id=3ffef67e"
import script from "./institutionPatternTable.vue?vue&type=script&lang=js"
export * from "./institutionPatternTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports